angular.module('impactx.controlstructure').controller('BudgetCtrl', [
    '$scope',
    BudgetCtrl]
);

function BudgetCtrl($scope) {
    $scope.changeTemplate = function (selected) {
        $scope.fixedEntries = {};
        if (selected) {
            if (selected.yearBudget) {
                $scope.budget.yearBudget.startValue.value = selected.yearBudget;
                $scope.budget.yearBudget.inUse.value = true;
                $scope.fixedEntries.year = true;
            }
            else {
                $scope.budget.yearBudget.inUse.value = false;
            }
            if (selected.monthBudget) {
                $scope.budget.monthBudget.startValue.value = selected.monthBudget;
                $scope.budget.monthBudget.inUse.value = true;
                $scope.fixedEntries.month = true;
            }
            else {
                $scope.budget.monthBudget.inUse.value = false;
            }
            if (selected.weekBudget) {
                $scope.budget.weekBudget.startValue.value = selected.weekBudget;
                $scope.budget.weekBudget.inUse.value = true;
                $scope.fixedEntries.week = true;
            }
            else {
                $scope.budget.weekBudget.inUse.value = false;
            }
            if (selected.dayBudget) {
                $scope.budget.dayBudget.startValue.value = selected.dayBudget;
                $scope.budget.dayBudget.inUse.value = true;
                $scope.fixedEntries.day = true;
            }
            else {
                $scope.budget.dayBudget.inUse.value = false;
            }
        }
    }
}